<template>
  <div class="app-container">
    <el-row :gutter="20" style="margin-top: 20px">
      <el-col :span="10" :xs="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>个人信息</span>
          </div>
          <div>
            <ul>
              <li class="list-group-item">
                <span style="width: 100px;flex: none"><i class="el-icon-user-solid"/>登录账号</span>
                <div class="pull-right">{{ userData.username }}</div>
              </li>
              <div>
                <li class="list-group-item">
                  <span style="width: 50px;flex: none"><i class="el-icon-user-solid"/>姓名</span>
                  <div>{{ userData.realName }}</div>
                </li>
                <li class="list-group-item">
                  <span style="width: 100px;flex: none"><i class="el-icon-s-check"/>uuid</span>
                  <div>{{ userData.personUuids[0] }}</div>
                </li>
                <li class="list-group-item">
                  <span style="width: 100px;flex: none"><i class="el-icon-star-on"/>权限等级</span>
                  <div>{{ userData.roles }}</div>
                </li>
              </div>
            </ul>
          </div>
        </el-card>
      </el-col>
<!--      <el-col :span="14" :xs="24">-->
<!--        <el-card>-->
<!--          <div slot="header" class="clearfix">-->
<!--            <span>{{ activeName }}</span>-->
<!--          </div>-->
<!--              <el-form v-if="isShowFormPwd" ref="formPwd" :model="userPwd" label-width="80px" :rules="rulesPwd">-->
<!--                <el-form-item label="旧密码" prop="pass">-->
<!--                  <el-input v-model="userPwd.pass" placeholder="请输入旧密码" type="password" show-password/>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="新密码" prop="newPass">-->
<!--                  <el-input v-model="userPwd.newPass" placeholder="请输入新密码" type="password" show-password/>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="确认密码" prop="confirmPassword">-->
<!--                  <el-input v-model="userPwd.confirmPassword" placeholder="请确认新密码" type="password" show-password/>-->
<!--                </el-form-item>-->
<!--                <el-form-item>-->
<!--                  <div style="display: flex;justify-content: space-between">-->
<!--                    <el-button type="primary" size="mini" @click="submitPwd('PASS')">保存</el-button>-->
<!--                  </div>-->
<!--                </el-form-item>-->
<!--              </el-form>-->
<!--        </el-card>-->
<!--      </el-col>-->
    </el-row>
  </div>
</template>

<script>
import {getDataInLocalStorage} from "@/utils/localStorage";

export default {
  name: "UserInfo",

  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.userPwd.newPass !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      userData: {},
      userPwd: {
        pass: '',
        newPass: '',
        confirmPassword: ''
      },
      oldPassWord: '',
      activeName: "修改密码",
      editUserInfoForm:{
        telephone:''
      },
      //个人信息的规则
      rules: {
        telephone: [
          {pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: '请输入正确的电话号码', trigger: 'blur'}
        ],
      },
      //重置密码的规则
      rulesPwd: {
        pass: [
          {required: true, message: "不能为空", trigger: "blur"}
        ],
        newPass: [
          {required: true, message: "新密码不能为空", trigger: "blur"},
          {min: 6, max: 20, message: "长度在 6 到 20 个字符", trigger: "blur"}
        ],
        confirmPassword: [
          {required: true, message: "确认密码不能为空", trigger: "blur"},
          {required: true, validator: equalToPassword, trigger: "blur"}
        ]
      },
      userName: '',
      verifyImgUrl: '',
      btnText: '60s',
      showTime: false,
      codeForm: {
        account: '',
        captcha: ''
      },
      isShowFormPwd: true,
    };

  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
  },
  methods: {
    handleEdit(){
      this.showTelDialog=true
    },
    // //提交个人信息的修改
    // submitEdit() {
    //   const data = {
    //     phoneNumber: this.editUserInfoForm.telephone,
    //   }
    //   this.$refs.editUserInfoForm.validate(valid => {
    //     if (valid) {
    //       this.showTelDialog=false
    //       updateUserInfo(data).then(res => {
    //         if (res.code === 200) {
    //           this.$message.success('保存成功')
    //           this.getUserInfo()
    //         } else {
    //           this.$message.error('保存失败')
    //         }
    //       })
    //     }
    //   })
    // },
    //密码的修改
    // submitPwd(method) {
    //   this.$refs['formPwd'].validate(valid => {
    //     if (valid) {
    //       const data = {
    //         pass: this.userPwd.pass,
    //         newPass: this.userPwd.newPass,
    //         method: method
    //       }
    //       updatePass(data).then(res => {
    //         if (res.code === 200) {
    //           this.$message.success('密码修改成功,请重新登录')
    //           removeDataInLocalStorage('userInfo')
    //           this.$router.push('/login')
    //         } else {
    //           this.$message.error('密码修改失败')
    //         }
    //       })
    //     }
    //   })
    // }
  }
};
</script>
<style scoped>

.list-group-item {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e7eaec;
  padding: 11px 0px;

}


</style>
